// Which admin pages each kind of staff member may open (mirrors
// server/src/utils/permissions.js - the server enforces it as well).
export const PAGES = [
  ['dashboard', 'Dashboard'], ['pos', 'POS'], ['orders', 'Orders'], ['kitchen', 'Kitchen'], ['cashier', 'Cashier'],
  ['menu', 'Menu'], ['products', 'Products'], ['tables', 'Tables'], ['reservations', 'Reservations'],
  ['bookings', 'Bookings'], ['services', 'Services'], ['availability', 'Availability'], ['inventory', 'Inventory'],
  ['shipping', 'Shipping'], ['customers', 'Customers'], ['reports', 'Reports'], ['employees', 'Employees'],
  ['whatsapp', 'WhatsApp'],
]

// Only the owner/admin: the store's settings, design and plan.
export const ADMIN_ONLY = ['settings', 'billing', 'website']
const ALL = [...PAGES.map(([key]) => key), ...ADMIN_ONLY]

export const ROLE_PAGES = {
  manager: PAGES.map(([key]) => key),
  cashier: ['dashboard', 'pos', 'orders', 'cashier', 'customers'],
  waiter: ['pos', 'orders', 'tables', 'reservations'],
  kitchen: ['kitchen'],
}

// Ready-made roles saved as "staff" with these pages (editable afterwards).
export const ROLE_PRESETS = [
  { id: 'driver', label: 'Delivery driver', pages: ['orders'] },
  { id: 'accountant', label: 'Accountant', pages: ['dashboard', 'reports', 'orders'] },
  { id: 'stock', label: 'Stock keeper', pages: ['inventory', 'menu', 'products'] },
  { id: 'receptionist', label: 'Receptionist', pages: ['bookings', 'reservations', 'availability', 'customers'] },
  { id: 'marketing', label: 'Marketing', pages: ['customers', 'whatsapp'] },
]

// The pages a signed-in person may open. `user.pages` comes from the server.
export function allowedPages(user) {
  if (!user) return []
  if (user.role === 'owner' || user.role === 'admin') return ALL
  if (Array.isArray(user.pages)) return user.pages
  return ROLE_PAGES[user.role] || []
}
